exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".InputWithIcon__InputWithIcon__1wtvm- {\n  display: flex;\n  width: 100%;\n}\n.InputWithIcon__InputWithIcon__1wtvm- label {\n  flex-shrink: 0;\n  flex-grow: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  text-align: center;\n  background: linear-gradient(to bottom, #fcfcfc, #eee);\n  border: 1px solid #d9d9d9;\n  border-right: none;\n  border-radius: 3px 0 0 3px;\n  color: #6b717d;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.InputWithIcon__InputWithIcon__1wtvm- input {\n  flex: 1 100%;\n  display: block;\n  width: 100%;\n  margin-bottom: 0;\n  border-radius: 0 3px 3px 0;\n  border-left-color: #d9d9d9;\n}\n.InputWithIcon__InputWithIcon__1wtvm- input:focus {\n  border-left-color: #528bff;\n}\n.InputWithIcon__InputWithIcon__1wtvm- input[disabled] {\n  background: #d7dae0;\n  cursor: not-allowed;\n}\n", ""]);

// exports
exports.locals = {
	"InputWithIcon": "InputWithIcon__InputWithIcon__1wtvm-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/InputWithIcon.styl
// module id = 3444
// module chunks = 39